import React from 'react';

const ModelosPlacaRollo = () => {
  const modelos = [
    {
      nombre: 'Blanco, Negro y Dorado',
      imagen: 'blanco-negro-dorado-1.jpeg'
    },
    {
      nombre: 'Gris, Blanco y Dorado',
      imagen: 'gris-blanco-dorado.jpeg'
    },
    {
      nombre: 'Beige, Gris y Cobre',
      imagen: 'beige-gris-cobre.jpeg'
    },
    {
      nombre: 'Blanco, Gris y Ocre',
      imagen: 'blanco-gris-ocre.jpeg'
    },
    {
      nombre: 'Blanco, Gris y Crema',
      imagen: 'blanco-gris-crema.jpeg'
    },
    {
      nombre: 'Blanco, Negro y Dorado',
      imagen: 'blanco-negro-dorado.jpeg'
    },
    {
      nombre: 'Blanco y Cobre',
      imagen: 'blanco-cobre.jpeg'
    },
    {
      nombre: 'Beige, Gris y Ocre',
      imagen: 'beige-gris-ocre.jpeg'
    },
    {
      nombre: 'Madera con Negro',
      imagen: 'madera.jpeg'
    }
  ];

  const ventajas = [
    {
      icono: 'ti-user',
      titulo: 'Sin instaladores profesionales',
      descripcion: 'Tú mismo puedes instalarlas en minutos'
    },
    {
      icono: 'ti-settings',
      titulo: 'Sin herramientas especiales',
      descripcion: 'Solo necesitas tijeras o cúter'
    },
    {
      icono: 'ti-shield',
      titulo: 'Sin perforaciones en muro',
      descripcion: 'Sistema autoadherible que respeta tus paredes'
    },
    {
      icono: 'ti-move',
      titulo: 'Flexibilidad total',
      descripcion: 'Se adapta a superficies curvas y esquinas'
    },
    {
      icono: 'ti-reload',
      titulo: 'Reposicionable',
      descripcion: 'Puedes ajustar durante la instalación'
    },
    {
      icono: 'ti-home',
      titulo: 'Ideal para rentas',
      descripcion: 'Instalación temporal sin dañar muros'
    }
  ];

  return (
    <section className="bg-light">
      <div className="container">
        <div className="row justify-content-center mb-2-9">
          <div className="col-lg-10 text-center">
            <p className="text-primary font-weight-800 text-uppercase mb-2">
              Variedad de diseños con vetas naturales tipo mármol
            </p>
            <div className="title-style2 mb-0 wow fadeIn" data-wow-delay="100ms">
              <h2 className="h1">Modelos de Placas en Rollo Autoadhesivas</h2>
            </div>
          </div>
        </div>

        <div className="row mt-n1-9 justify-content-center">
          {modelos.map((modelo, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-6 mt-1-9">
              <div className="card border-0 h-100 wow fadeIn" data-wow-delay={`${(index + 1) * 100}ms`}>
                <div className="card-body p-0">
                  <div className="overflow-hidden position-relative">
                    <img 
                      src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/rollo-marmol/${modelo.imagen}`}
                      alt={modelo.nombre}
                      className="w-100"
                    />
                  </div>
                  <div className="p-1-6 p-lg-1-9 text-center">
                    <h3 className="h5 mb-0">{modelo.nombre}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sección de Ventajas en Card */}
        <div className="row mt-2-9 mt-lg-4-9">
          <div className="col-12">
            <div className="card border-0 shadow-sm wow fadeIn" data-wow-delay="100ms">
              <div className="card-body p-2-3 p-lg-3-0">
                <div className="row justify-content-center mb-2-5 mb-lg-3-0">
                  <div className="col-lg-10 text-center">
                    <div className="title-style2 mb-0">
                      <h2 className="h3 h4-lg">Ventajas de las placas en rollo autoadhesivas</h2>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {ventajas.map((ventaja, index) => (
                    <div key={index} className="col-lg-4 col-md-6 col-12 mb-2-5 mb-md-3-0">
                      <div className="d-flex align-items-start h-100">
                        <div className="flex-shrink-0 me-3 me-lg-4">
                          <i className={`${ventaja.icono} text-primary display-5`}></i>
                        </div>
                        <div className="flex-grow-1">
                          <h3 className="h6 h5-lg mb-2 font-weight-700">{ventaja.titulo}</h3>
                          <p className="mb-0 text-sm">{ventaja.descripcion}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModelosPlacaRollo;